import * as signalR from '@microsoft/signalr';
import ApiUrl from './config';

// Тот же ключ, что и в AuthContext.tsx — берём токен судьи, чтобы хаб мог
// проверить право на отправку событий (см. RequireMatchManagement на backend).
const getStoredToken = (): string => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return parsed?.token || '';
  } catch {
    return '';
  }
};

export const createMatchHubConnection = (): signalR.HubConnection => {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${ApiUrl}/hubs/match`, {
      // withCredentials: true потребовал бы CORS-политику с конкретными origin вместо AllowAnyOrigin.
      // Нам это не нужно — токен передаём сами через accessTokenFactory.
      withCredentials: false,
      accessTokenFactory: () => getStoredToken(),
    })
    .withAutomaticReconnect([0, 1000, 2000, 5000, 10000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();
};

export type OsaekomiSide = 'home' | 'away' | null;

export interface MatchLiveState {
  matchId: number;
  homeName: string;
  awayName: string;

  homeIppon: number;
  homeWazaAri: number;
  homeYuko: number;
  homeShido: number;

  awayIppon: number;
  awayWazaAri: number;
  awayYuko: number;
  awayShido: number;

  isStarted: boolean;
  isPaused: boolean;

  // ISO-строка момента, от которого табло само крутит отсчёт локально (не тикаем по сети).
  timerAnchorUtc: string | null;
  timeRemainingMsAtAnchor: number;
  isTimerRunning: boolean;

  osaekomiSide: OsaekomiSide;
  osaekomiStartedUtc: string | null;
}

export interface MatchEndedPayload {
  matchId: number;
  winnerName: string;
}
